<template>
  <transition name="component-fade" mode="out-in">
    <content-placeholders v-if="isLoading" rounded>
      <content-placeholders-img style="height: 24px; width: 150px;" />
    </content-placeholders>
    <p v-else class="count-items-tab">
      {{ text }}
    </p>
  </transition>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';

import plural from '@/utils/plural';

export default defineComponent({
  name: 'CountItems',
  props: {
    isLoading: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
  },
  setup(props) {
    const text = computed(() => {
      const textForCount = plural(props.count, ['товар', 'товара', 'товаров']);

      return `${props.count} ${textForCount}`;
    });

    return { text };
  },
});
</script>

<style lang="less">
.count-items-tab {
  .p();

  margin: 0;
  color: @gray-dark;
}
</style>
